import * as types from "../../mutation-types";

export default {
    [types.FETCH_QUIZ_SUCCESS](state, data) {
        state.quiz = data
    },

    [types.FETCH_QUIZ_FAILURE](state) {
        state.quiz = null
    },

    [types.LEAVE_QUIZ](state) {
        state.quiz = null
    },

    [types.FETCH_PROFILE_SUCCESS](state, data) {
        state.profile = data.answers
    },

    [types.FETCH_PROFILE_FAILURE](state) {
        state.profile = null
    },

    [types.FETCH_REGIMEN_ELEMENTS_SUCCESS](state, data) {
        state.regimenElements = data
    },

    [types.FETCH_REGIMEN_ELEMENTS_FAILURE](state) {
        state.regimenElements = null
    },

    [types.FETCH_ALL_REGIMEN_ELEMENTS_SUCCESS](state, data) {
        state.allRegimenElements = data
    },

    [types.FETCH_ALL_REGIMEN_ELEMENTS_FAILURE](state) {
        state.allRegimenElements = null
    },

    [types.FETCH_USER_REGIMEN_ELEMENTS_SUCCESS](state, data) {
        state.userRegimenElements = data
    },

    [types.FETCH_USER_REGIMEN_ELEMENTS_FAILURE](state) {
        state.userRegimenElements = null
    },

    [types.FETCH_NOTES_SUCCESS](state, data) {
        state.notes = data
    },

    [types.FETCH_NOTES_FAILURE](state) {
        state.notes = null
    },

    [types.FETCH_INSIGHTS_SUCCESS](state, data) {
        state.insights = data
    },

    [types.FETCH_INSIGHTS_FAILURE](state) {
        state.insights = null
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/quiz/mutations.js